<template>
  <div id="index" class="mx-auto px-4 flex space-x-2 p-5 h-screen">
    <div id='block-search' v-if="$root.hotelCode == 'miracleon'">
      <div id='tl-search-form' class='tl-container'>
        <a href='https://www.travelline.ru/products/tl-hotel/' target='_blank'></a>
      </div>
    </div>

    <div class="w-2/5">
      <div class="flex flex-col relative top-0 relative h-full" id="wrapper">
        <div class="h-full">
          <video v-if="$root.template === 'video_template'" autoplay muted playsinline preload="auto"
                 :src="$root.hotel.main_video" loop
                 class="object-cover w-full h-full rounded-lg">
            Your browser does not support the video tag.
          </video>
          <a-carousel class="h-screen w-full" effect="fade" :dots="false" autoplay
                      v-if="$root.template === 'slider_template' && sliders">
            <div class="bg-carousel-hotel object-cover bg-cover absolute top-0 left-0 w-full h-screen z-[6]"
                 v-if="sliders[0] !== undefined"
                 :style="'background-image: url(' + $root.getImage($root.getImage(sliders[0])) + ')'">
            </div>
            <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[5]"
                 v-if="sliders[1] !== undefined"
                 :style="'background-image: url(' + $root.getImage($root.getImage(sliders[1])) + ')'">
            </div>
            <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[4]"
                 v-if="sliders[2] !== undefined"
                 :style="'background-image: url(' + $root.getImage($root.getImage(sliders[2])) + ')'"></div>
            <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[3]"
                 v-if="sliders[3] !== undefined"
                 :style="'background-image: url(' + $root.getImage($root.getImage(sliders[3])) + ')'"></div>
            <div class="bg-carousel-hotel bg-cover absolute top-0 left-0 w-full h-screen z-[2]"
                 v-if="sliders[4] !== undefined"
                 :style="'background-image: url(' + $root.getImage($root.getImage(sliders[4])) + ')'"></div>
          </a-carousel>
        </div>

        <div class="bg-gradient-to-b from-[#00000075] p-[10px] to-transparent flex items-center h-full justify-between flex-col absolute top-0 left-0 w-full get-screen rounded-lg"
             id="screen">

          <div class="flex flex-col w-full items-center">
            <div class="flex justify-between w-full p-[10px]">
              <p class="flex items-center text-[#fff] text-[16px]">
                <span class="pr-2">{{ crntDate }}</span> | <span class="px-2">{{ crntTime }}</span> |
                <span class="px-2">{{ correctWeather }}°C</span>
              </p>
              <select-language class="mx-4"></select-language>
            </div>
            <img class="max-w-[250px] mt-[50px]" :src="$root.getImage($root.hotel.logo_main_page)" alt="">
            <p class="text-[#fff] mt-3 text-center">{{ $root.getLangText($root.hotel.template_subtitle) }}</p>
            <welcome-guest-message/>
          </div>
        </div>

      </div>
    </div>

    <div class="w-3/5 overflow-y-auto rounded-lg">
      <div class="flex flex-col space-y-4">
        <TopBanner/>
        <div class="px-2">
          <app-sections></app-sections>
        </div>
        <div class="slide-banner ml-2">
          <app-banner></app-banner>
        </div>
        <div style="margin-bottom: 60px;">
          <app-social></app-social>
          <app-footer></app-footer>
        </div>
        <article-extra-popup></article-extra-popup>
      </div>
    </div>
  </div>
</template>

<script>
import TopBanner from "../../components/article/TopBanner";
import AppSections from "../../components/article/AppSections.vue";
import AppSocial from "../../components/layout/AppSocial";
import AppBanner from "../../components/article/AppBanner";
import ArticleExtraPopup from './../Product/ArticleExtraPopup';
import AppHeader from "@/components/layout/header/AppHeader.vue";
import selectLanguage from "@/components/layout/header/ArticleSelectLang.vue";
import WelcomeGuestMessage from "@/components/layout/WelcomeGuestMessage.vue";
import AppFooter from "@/components/layout/AppFooter.vue";


export default {
  name: "HomeNew",

  components: {
    AppFooter,
    WelcomeGuestMessage,
    selectLanguage, AppHeader, TopBanner, AppSections, AppBanner, AppSocial, ArticleExtraPopup
  },

  computed: {
    correctWeather() {
      let weather = this.$root.weather.substring(0, this.$root.weather.indexOf('.'));
      return weather[0] === '-' ? weather.substr(0, 3) : weather.substr(0, 2);
    },
    sliders() {
      return JSON.parse(this.$root.hotel.template_sliders);
    },
  },

  data() {
    return {
      crntTime: '',
      crntDate: '',
    }
  },


  mounted() {
    window.scrollTo(0, 0);

    /* remove div.overlist from dom on Back Button if exists */
    if (document.getElementsByClassName('overlist')[0] !== undefined) {
      let elem = document.getElementsByClassName('overlist')[0];
      elem.parentNode.removeChild(elem);
    }

    setInterval(function () {
      this.currentDate();
      this.currentTime();
    }.bind(this), 2000);
  },

  methods: {
    currentDate() {
      let today    = new Date();
      let timezone = this.$root.hotel.ext_data.timezone.replace('posix/', '');
      let locale   = '';
      locale       = process.env.VUE_APP_SERVER.toLowerCase() === 'ca' ? 'en-EN' : 'ru-RU';
      today        = today.toLocaleDateString(locale, {
        day     : '2-digit',
        month   : '2-digit',
        year    : 'numeric',
        timeZone: timezone
      });

      if (locale === 'ru-RU') {
        today = today.replaceAll('.', '\u00B7');
      } else {
        today = today.replaceAll('/', '\u00B7');
      }
      this.crntDate = today;
    },

    currentTime() {
      let time     = new Date();
      let timezone = this.$root.hotel.ext_data.timezone.replace('posix/', '');
      if (process.env.VUE_APP_SERVER.toLowerCase() === 'ru') {
        time = time.toLocaleString('ru-RU', {
          hour    : 'numeric',
          minute  : 'numeric',
          hour12  : false,
          timeZone: timezone
        });
      } else {
        time = time.toLocaleString('en-EN', {
          hour    : 'numeric',
          minute  : 'numeric',
          hour12  : true,
          timeZone: timezone
        });
      }

      this.crntTime = time;
    },
  }
}
</script>